import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { LabeledPdfRows } from './LabeledPdfBlock';
import { usePdfStyles } from './PdfPrintScaleContext';

/**
 * Stacked labeled sections (same layout as invoice totals): half-width column, optional dividers.
 * @param {{ sections: Array<{ title: string; rows: Array<{ label: string; value: unknown }>; wrap?: boolean }> }} props
 */
export function PdfLabeledSections({ sections }) {
    const pdfStyles = usePdfStyles();

    return (
        <View>
            {sections.map((section, index) => (
                <View key={section.title} wrap={section.wrap ?? false}>
                    {index > 0 ? <View style={pdfStyles.sectionDivider} /> : null}
                    <Text
                        style={
                            index > 0 ? pdfStyles.sectionTitleCompact : pdfStyles.sectionTitle
                        }
                    >
                        {section.title}
                    </Text>
                    <View style={pdfStyles.twoCol}>
                        <View style={pdfStyles.col}>
                            <LabeledPdfRows rows={section.rows} />
                        </View>
                        <View style={pdfStyles.col} />
                    </View>
                </View>
            ))}
        </View>
    );
}
